<app-common-header
  [blur]="true"
  [title]="'Side ikke funnet'"
  [description]="'Det har oppstått en feil. Vennligst sjekk at url-en er riktig. Hvis problemet oppstår flere ganger, vennligst ta kontakt'"
  [imageData]="['img/home.png']">
</app-common-header>

<app-shortcuts [isPage]="true" [isCollapsed]="true"></app-shortcuts>
